module.exports = __webpack_public_path__ + "img/9788980409235.d869ece5.jpg";